import React from 'react';
import styled from 'styled-components';
import { Outlet, useNavigate, useParams, useLocation } from 'react-router-dom';
import { Breadcrumb } from 'antd';
import { COLORS } from '../../utils/constants';
import {
  buildDoublesBracketsPath,
  buildSinglesBracketsPath,
  EVENTMANAGEMENTPATH,
} from '../../routes/routePaths';
import { EventProvider, useEventContext } from '../../contexts/EventContext';
import Spinner from '../common/Spinner';
import { TournamentTypeString } from '../../enums/enums';

const EventDetailsLayoutContent: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { tournamentId } = useParams<{ tournamentId: string }>();
  const { eventData, loading, sportName, tournamentType } = useEventContext();

  return (
    <Wrapper>
      <Breadcrumb>
        <Crumb
          onClick={() =>
            navigate(EVENTMANAGEMENTPATH, { state: location.state })
          }
        >
          Event Management
        </Crumb>
        <Crumb
          onClick={() =>
            navigate(`${EVENTMANAGEMENTPATH}/${eventData?.eventId}`, {
              state: location.state,
            })
          }
        >
          {eventData?.eventName || ''}
        </Crumb>
        {tournamentId && sportName && tournamentType && (
          <Crumb
            onClick={
              location.pathname.endsWith('/score')
                ? () =>
                    tournamentType === TournamentTypeString.Singles
                      ? navigate(
                          `${buildSinglesBracketsPath(Number(tournamentId))}${location.search}`,
                        )
                      : navigate(
                          `${buildDoublesBracketsPath(Number(tournamentId))}${location.search}`,
                        )
                : undefined
            }
          >{` ${sportName} - ${tournamentType}`}</Crumb>
        )}
        {location.pathname.endsWith('/score') && <Crumb>score</Crumb>}
      </Breadcrumb>
      <Content>
        {loading ? (
          <LoadingContainer>
            <Spinner />
          </LoadingContainer>
        ) : (
          <Outlet />
        )}
      </Content>
    </Wrapper>
  );
};

const EventDetailsLayout: React.FC = () => {
  return (
    <EventProvider>
      <EventDetailsLayoutContent />
    </EventProvider>
  );
};

export default EventDetailsLayout;

/* Styled Components */
const Wrapper = styled.div`
  background: ${COLORS.white.primary};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
`;

export const Crumb = styled(Breadcrumb.Item)`
  &.ant-breadcrumb-link:hover {
    cursor: pointer;
    color: ${COLORS.skyBlue.primary};
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const Content = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;
